import { Sparkline } from './Sparkline.jsx';

export function TempCard({ eq }) {
  const hasReading = eq.current_temp_f != null && Number.isFinite(eq.current_temp_f);
  const inRange = eq.in_range;
  const alarming = !!eq.alarm_active_since;
  const borderColor = alarming ? '#b00020' : (inRange === false ? '#b48a47' : '#e0e0e0');
  const bg = alarming ? '#fdecef' : (inRange === false ? '#fff8e7' : '#fff');
  const lastTime = eq.current_at ? new Date(eq.current_at) : null;
  const minSinceReading = lastTime ? Math.round((Date.now() - lastTime.getTime()) / 60000) : null;
  const stale = minSinceReading != null && minSinceReading > 30; // >30 min without an update
  return (
    <div style={{ border: `1px solid ${borderColor}`, borderRadius: 8, padding: 12, background: bg }}>
      <div style={{ fontSize: 13, fontWeight: 700, color: '#212121',
                    overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={eq.name}>
        {eq.name}
      </div>
      <div style={{ fontSize: 11, color: '#757575', marginBottom: 6 }}>
        {eq.type || 'Equipment'}
        {eq.temp_low_f != null && eq.temp_high_f != null && (
          <> · Range {eq.temp_low_f}°–{eq.temp_high_f}°F</>
        )}
      </div>

      <div style={{ display: 'flex', alignItems: 'baseline', gap: 8 }}>
        <div style={{ fontSize: 26, fontWeight: 700,
                      color: alarming ? '#b00020' : (inRange === false ? '#b48a47' : '#212121') }}>
          {hasReading ? `${eq.current_temp_f.toFixed(1)}°F` : '—'}
        </div>
        {alarming && <span style={{ fontSize: 11, fontWeight: 700, color: '#b00020' }}>ALARM</span>}
        {!alarming && inRange === false && <span style={{ fontSize: 11, fontWeight: 700, color: '#b48a47' }}>Out of range</span>}
      </div>

      <Sparkline points={eq.sparkline} low={eq.temp_low_f} high={eq.temp_high_f} />

      <div style={{ fontSize: 11, color: stale ? '#b00020' : '#9e9e9e', marginTop: 4 }}>
        {minSinceReading == null ? 'No readings yet'
          : minSinceReading < 1 ? 'Updated just now'
          : minSinceReading < 60 ? `Updated ${minSinceReading} min ago`
          : `Updated ${Math.round(minSinceReading / 60)} hr ago`}
      </div>
    </div>
  );
}
